// extracted by mini-css-extract-plugin
export default {"container":"styles_container__Wk2DD","input":"styles_input__yWHgz","resultContainer":"styles_resultContainer__O1abq","footer":"styles_footer__OkmQU"};